var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slds-progress-bar",attrs:{"aria-valuemin":"0","aria-valuemax":"100","aria-valuenow":_vm.progress,"role":"progressbar"}},[_c('span',{staticClass:"slds-progress-bar__value",style:('width:'+_vm.progress+'%')},[_c('span',{staticClass:"slds-assistive-text"},[_vm._v("Progress: "+_vm._s(_vm.progress)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }